import socialPlatformDetails from "../../config/socialPlatforms";
import { editorHtmlToText } from "../CompactPostEditor";

// Shared by AI Post Studio and Manual Post Studio. Keep workflow-specific logic in the pages.
export const studioPlatforms = ["instagram", "facebook", "linkedin", "x", "youtube"];
export const postStatuses = ["DRAFT", "APPROVED", "SCHEDULED", "PUBLISHING", "PUBLISHED", "FAILED", "CANCELLED"];
export const statusLabels = {
  DRAFT: "Draft", APPROVED: "Ready", SCHEDULED: "Scheduled", PUBLISHING: "Publishing", PUBLISHED: "Published", FAILED: "Failed", CANCELLED: "Cancelled"
};
// Platform caption limits used for live validation hints.
export const captionLimits = { instagram: 2200, facebook: 6000, linkedin: 3000, x: 280, youtube: 5000 };

export const studioRoutes = {
  AI: { list: "/ai-post-studio", create: "/ai-post-studio/create", edit: (id) => `/ai-post-studio/${id}/edit` },
  MANUAL: { list: "/manual-post-studio", create: "/manual-post-studio/create", edit: (id) => `/manual-post-studio/${id}/edit` }
};
export const studioForPost = (post) => studioRoutes[post?.generationSource === "AI" ? "AI" : "MANUAL"];

export const platformName = (platform) => socialPlatformDetails[platform]?.name || platform || "Platform not set";
export const platformIcon = (platform) => socialPlatformDetails[platform]?.icon || "ti-world";

export const monthKey = (date = new Date()) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
export const shiftMonth = (month, offset) => {
  const [year, number] = month.split("-").map(Number);
  return monthKey(new Date(year, number - 1 + offset, 1));
};
export const monthTitle = (month) => new Date(`${month}-01T12:00:00`).toLocaleDateString(undefined, { month: "long", year: "numeric" });

export const toDateTimeInput = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const formatPostDate = (value) => {
  if (!value) return "Not scheduled";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "Not scheduled" : date.toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

export const hashtagsToText = (value) => (Array.isArray(value) ? value : String(value || "").split(/[\s,]+/)).filter(Boolean).join(" ");
export const hashtagsToList = (value) => [...new Set((Array.isArray(value) ? value : String(value || "").split(/[\s,]+/))
  .map((tag) => String(tag).trim().replace(/^#*/, ""))
  .filter(Boolean)
  .map((tag) => `#${tag}`))].slice(0, 30);

export const postTitle = (post) => post?.title?.trim() || post?.topic?.trim() || plainCaption(post).split(/\s+/).slice(0, 9).join(" ") || "Untitled post";
// Manual posts store rich text in description and its plain-text form in caption.
export const plainCaption = (post) => post?.caption?.trim() || editorHtmlToText(post?.description || "");

export const isLocked = (post) => ["PUBLISHING", "PUBLISHED"].includes(post?.status);
